import { Injectable } from '@angular/core';
import { PreviewService } from './preview.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { config } from '../../../../lib/modules/shared/config';
import { forkJoin } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PreviewResolver {
  constructor(private previewService: PreviewService) {}
  resolve(route: ActivatedRouteSnapshot) {
    let lcid = config.defaultLcid;
    return forkJoin([
      this.previewService.fetchPreviewScorecard(),
      this.previewService.fetchPreviewMarketplace(+lcid),
      this.previewService.fetchPreviewLotto(+lcid),
      this.previewService.fetchPreviewAuction(+lcid),
    ]);
  }
}
